import { render, staticRenderFns } from "./SuggestRing.vue?vue&type=template&id=bc034dba&"
import script from "./SuggestRing.vue?vue&type=script&lang=js&"
export * from "./SuggestRing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports